import type { CheckedBaggageSummary } from '@eti/schema-types';
import { BaggageStatus } from '@eti/schema-types';
import { getIncludedBaggageText } from './getIncludedBaggageText';

const isCheckedBaggageIncluded = (
  checkedBaggageSummary: CheckedBaggageSummary,
  t: (key: any, ...params: any[]) => string,
) => {
  const { tripSummaries } = checkedBaggageSummary;
  if (tripSummaries && tripSummaries[0]?.baggageStatus !== BaggageStatus.IncludedCheckedBaggage) {
    return false;
  }

  const checkedInBaggageName =
    tripSummaries &&
    tripSummaries[0] &&
    getIncludedBaggageText(
      tripSummaries[0].baggageDetails,
      'IbeClient.CheckInBaggageIncluded.Label',
      t,
    );
  if (!checkedInBaggageName) {
    return false;
  }
  return true;
};

export default isCheckedBaggageIncluded;
